import React, { useEffect, useState } from 'react';
import { Accordion, ListGroup, Spinner, Button } from 'react-bootstrap';
import api from '../../api/axios';

const HistorialPedidosMesa = ({ mesaId, businessId, mostrarAcciones = false, onTotalChange }) => {

  const [pedidos, setPedidos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (mesaId && businessId) {
      fetchPedidos();
    }
  }, [mesaId, businessId]);

  const fetchPedidos = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/mesas/${mesaId}/historial-pedidos?business_id=${businessId}`);
      setPedidos(res.data || []);
      if (onTotalChange) {
  const totalGlobal = (res.data || []).reduce((acc, p) => acc + (p.total || 0), 0);
  onTotalChange(totalGlobal);
}

    } catch (err) {
      console.error('Error al traer historial de pedidos:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Spinner animation="border" />;

  if (pedidos.length === 0) return <p>No hay pedidos para esta mesa aún.</p>;

return (
  <Accordion alwaysOpen>
    {pedidos.map((pedido, idx) => (
      <Accordion.Item key={pedido.id} eventKey={idx.toString()}>
        <Accordion.Header>
  Pedido #{pedido.id} – {pedido.is_emitted ? '✅ Emitido' : '🟠 No emitido'} – {
    new Date(new Date(pedido.created_at).getTime() - new Date(pedido.created_at).getTimezoneOffset() * 60000)
      .toLocaleTimeString('es-AR', {
        hour: '2-digit',
        minute: '2-digit'
      })
  }
</Accordion.Header>

        <Accordion.Body>
          <ListGroup variant="flush">
            {pedido.items.map((item, i) => (
              <ListGroup.Item key={i}>
                <strong>{item.cantidad} x {item.nombre}</strong>
                {item.observacion && (
                  <div style={{ fontSize: '0.85rem', color: '#666' }}>
                    Observación: {item.observacion}
                
                  </div>

                )}
              </ListGroup.Item>
            ))}
          </ListGroup>

          {/* Total al final si tenés ese dato */}
          {pedido.total && (
            <div className="mt-2 text-end">
              <strong>Total: ${pedido.total}</strong>
            </div>
          )}
        </Accordion.Body>
      </Accordion.Item>
    ))}
  </Accordion>
);

};

export default HistorialPedidosMesa;
